import { render, staticRenderFns } from "./approval-type.vue?vue&type=template&id=5e73ad52&"
import script from "./approval-type.vue?vue&type=script&lang=js&"
export * from "./approval-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports